import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Logout from '../components/logout';
import * as headerAction from '../actions/headerAction';

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...headerAction,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Logout);
